import LazyLoad from "vanilla-lazyload";

const Common = {
  token: "",
  lazyLoadInstance: null,

  init: function () {
    Common.events();
    Common.search();
    Common.newsletterPopup();
    Common.lazyload();
    Common.accordions();
    Common.modal();
    Common.animateText();
    Common.scrollTop();
    Common.promoline();

    setTimeout(function () {
      Common.fancy_fields.init();
    }, 100);
  },

  fancy_fields: {
    init: function () {
      $(".fancy-field .field").each(function () {
        Common.fancy_fields.action($(this));
      });
      $(".fancy-field .field").on("change", function () {
        Common.fancy_fields.action($(this));
      });
    },
    action: function (input) {
      if (input.val()) {
        input.addClass("focus");
      } else {
        input.removeClass("focus");
      }
    },
  },

  events: function () {
    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // sm popup
    $("body").on("click", ".sm-popup__toggle", function () {
      $(this).closest(".sm-popup").toggleClass("sm-popup--open");
    });
    $("body").on("click", ".sm-popup__close", function () {
      $(this).closest(".sm-popup").toggleClass("sm-popup--closed");
    });

    $(document).on('click', '.add_to_cart_button.ajax_add_to_cart', function(){
      var $btn   = $(this),
        id     = $btn.data('product_id'),
        name   = $btn.closest('.product').find('h2.woocommerce-loop-product__title').text().trim(),
        price  = parseFloat(
          $btn.closest('.product').find('.price').text()
            .replace(/[^0-9\.,]/g,'')
            .replace(',', '.')
        ) || undefined,
        qty    = Number( $btn.data('quantity') ) || 1;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'EUR',
          items: [{
            item_id:    id,
            item_name:  name,
            price:      price,
            quantity:   qty
          }]
        }
      });
    });
  },

  search: function () {
    $("#searchsubmit").on("click", function (e) {
      e.preventDefault();

      if (helpers.validate($("#searchform"), false)) {
        $("#searchform").submit();
      }
    });
  },

  newsletterPopup() {
    $(".popup__close").on("click", (e) => {
      $(e.currentTarget).closest(".popup").addClass("hidden");

      $.ajax({
        url: ajaxurl,
        data: {
          action: "newsletter_subscribe",
        },
      });
    });

    $("#mc-embedded-subscribe-form").on("submit", (e) => {
      const formEl = $(e.currentTarget);

      if (!helpers.validate(formEl)) {
        e.preventDefault();
        return;
      }

      $(".popup--newsletter").addClass("hidden");

      $.ajax({
        url: ajaxurl,
        data: {
          action: "newsletter_subscribe",
        },
      });
    });
  },

  lazyload: function () {
    Common.lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazy",
    });
  },

  accordions: function () {
    var header = "accordion__header";
    var header_class = "." + header;
    var header_active = header + "--open";

    $("body").on("click", header_class, function () {
      var btn = $(this);
      var siblings = btn.parent().siblings();

      // Show content
      btn.next().slideToggle(250);

      // Close siblings
      siblings.children(header_class).removeClass(header_active);
      siblings.children(".accordion__body").slideUp(250);

      // Scroll to dropdown
      if (!btn.hasClass(header_active)) {
        setTimeout(function () {
          var scrollTo = btn.offset().top - $(".main").offset().top;
          $("html, body").animate(
            {
              scrollTop: scrollTo - $(".header").height() - 20,
            },
            250
          );
        }, 250);
      }

      // Animate header
      btn.toggleClass(header_active);
    });
  },

  modal() {
    $("[data-modal]").on("click", (e) => {
      const target = $(e.currentTarget).data("modal");
      if (!target) {
        return;
      }
      const targetEl = $(target);
      if (!targetEl.length) {
        return;
      }

      targetEl.addClass("visible");
    });

    $(".modal .modal__close").on("click", (e) => {
      $(e.currentTarget).closest(".modal").removeClass("visible");
    });

    $(document).mouseup(function (e) {
      var container = $(".modal__box");
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.closest(".modal").removeClass("visible");
      }
    });
  },

  animateText() {
    const blocks = document.querySelectorAll(".animate-block");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const element = entry.target.querySelector(".animate-element");
          if (entry.isIntersecting) {
            element.classList.add("animated");
          }
        });
      },
      {
        threshold: 0.7,
      }
    );

    blocks.forEach((item) => {
      observer.observe(item);
    });
  },

  scrollTop() {

    const handleScrollTop = () => {
      const btnEl = $("#scrolltop");

      $(document).ready(function () {
        if ($(window).width() > 600) {
          $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
              btnEl.fadeIn();
            } else {
              btnEl.fadeOut();
            }
          });

          btnEl.click(function () {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
            return false;
          });
        }
      });

      $(window).resize(function () {
        if ($(window).width() > 600) {
          $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
              btnEl.fadeIn();
            } else {
              btnEl.fadeOut();
            }
          });

          btnEl.click(function () {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
            return false;
          });
        } else {
          btnEl.hide();
          $(window).off("scroll");
          btnEl.off("click");
        }
      });
    }

    handleScrollTop();
  },

  promoline() {
    const promoLineEl = document.querySelector(".promo-line");

    if (!promoLineEl) {
      return
    }

    const isHidden = sessionStorage.getItem("promolineIsHidden");

    if (!isHidden) {
      promoLineEl.classList.add("visible");
    }

    const btn = promoLineEl.querySelector(".promo-line__close");
    btn.addEventListener("click", () => {
      promoLineEl.classList.remove("visible");
      sessionStorage.setItem("promolineIsHidden", "true");
    })
  }
};
export default Common;
